export function useValidation(){
    const isValidEmail = (email: string): boolean => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };
    
    const isValidCPFStructure = (cpf: string): boolean => {
      const cleanCPF = cpf.replace(/\D/g, '');
      if (cleanCPF.length !== 11) return false;
      
      if (/^(\d)\1{10}$/.test(cleanCPF)) return false;
    
      let sum = 0;
      for (let i = 0; i < 9; i++) {
        sum += parseInt(cleanCPF.charAt(i)) * (10 - i);
      }
      
      let remainder = (sum * 10) % 11;
      if (remainder === 10 || remainder === 11) remainder = 0;
      if (remainder !== parseInt(cleanCPF.charAt(9))) return false;
    
      sum = 0;
      for (let i = 0; i < 10; i++) {
        sum += parseInt(cleanCPF.charAt(i)) * (11 - i);
      }
      
      remainder = (sum * 10) % 11;
      if (remainder === 10 || remainder === 11) remainder = 0;
      if (remainder !== parseInt(cleanCPF.charAt(10))) return false;
    
      return true;
    };
    
    const isValidCNPJStructure = (cnpj: string): boolean => {
      const cleanCNPJ = cnpj.replace(/\D/g, '');
      if (cleanCNPJ.length !== 14) return false;
    
      if (/^(\d)\1{13}$/.test(cleanCNPJ)) return false;
    
      let size = 12;
      let numbers = cleanCNPJ.substring(0, size);
      const digits = cleanCNPJ.substring(size);
      let sum = 0;
      let pos = size - 7;
    
      for (let i = size; i >= 1; i--) {
        sum += parseInt(numbers.charAt(size - i)) * pos--;
        if (pos < 2) pos = 9;
      }
    
      let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
      if (result !== parseInt(digits.charAt(0))) return false;
    
      size = 13;
      numbers = cleanCNPJ.substring(0, size);
      sum = 0;
      pos = size - 7;
    
      for (let i = size; i >= 1; i--) {
        sum += parseInt(numbers.charAt(size - i)) * pos--;
        if (pos < 2) pos = 9;
      }
    
      result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
      if (result !== parseInt(digits.charAt(1))) return false;
    
      return true;
    };

    return{
        isValidEmail,
        isValidCPFStructure,
        isValidCNPJStructure
    }
}